/**
 * @classdesc URL解析系のユーティリティ クラス
 */
export default class UrlUtils {
    /**
     * Query 取得
     */
    static getQuery() {
        const params = new URLSearchParams(window.location.search);
        const queries = {};

        for (const [key, value] of params) {
            queries[key] = value;
        }

        return queries;
    }

    /**
     * srcに付加したURLパラメータを取得
     * src="test.js?○○
     * @retun {key:string}
     */
    static getSrcParam() {
        const scripts = document.getElementsByTagName('script');
        const src = scripts[scripts.length - 1].src;
        const query = src.substring(src.indexOf('?') + 1);
        const parameters = query.split('&');

        const result = {};
        for (var i = 0; i < parameters.length; i++) {
            const element = parameters[i].split('=');
            const paramName = decodeURIComponent(element[0]);
            const paramValue = decodeURIComponent(element[1]);
            result[paramName] = paramValue;
        }

        return result;
    }
}
